import Modal, { IModalComponentProps } from './Modal';

export default Modal;
export type { IModalComponentProps };
export { default as ModalComponent } from './Modal';
